import {eConsentActionTypes} from "./actionTypes";

export function setEConsentData(payload) {
    return {
        type: eConsentActionTypes.SET_ECONSENT_DATA,
        payload
    }
}

export function setEConsentSigned(payload) {
    return {
        type: eConsentActionTypes.SET_ECONSENT_SIGNED,
        payload
    }
}

export function setEConsentRevokeLogsOut(payload) {
    return {
        type: eConsentActionTypes.SET_ECONSENT_REVOKE_LOGS_OUT,
        payload
    }
}

export function setEConsentRevoked() {
    return {
        type: eConsentActionTypes.SET_ECONSENT_REVOKED,
    }
}
